import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const TIPS = [
  ["1. Pick a goal", "It pre-sets the signals and scoring that usually matter for that kind of opportunity."],
  ["2. Describe it in your words", "Write what a perfect prospect looks like, then tap Build My Search Criteria. AI fills in the next steps for you."],
  ["3. Check each step", "Company, Jobs, Signals, Exclusions and People are all editable. Anything you leave blank isn't used as a filter."],
  ["4. Set what matters", "In Scoring, move sliders from Not important to Very High. The share next to each shows how much it counts."],
  ["5. Save and run", "Results land in Opportunity Radar with a 0-100 score, the evidence behind it and a Why Now? for hot ones."],
];

export const HowTo = () => (
  <Popover>
    <PopoverTrigger asChild><button type="button" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-[#27272A] px-2.5 py-1 text-xs text-zinc-300 hover:border-[#D4AF37]/60 hover:text-[#F3C649]" data-testid="wf-howto"><HelpCircle className="h-3.5 w-3.5" />How to use</button></PopoverTrigger>
    <PopoverContent align="end" className="w-80 border-[#27272A] bg-[#0f0b16] p-4" data-testid="wf-howto-panel">
      <p className="font-display text-base text-zinc-50">Build a sales opportunity radar</p>
      <div className="mt-2 space-y-2.5">{TIPS.map(([t, d]) => <div key={t}><p className="text-xs font-semibold text-[#F3C649]">{t}</p><p className="text-[11px] leading-relaxed text-zinc-400">{d}</p></div>)}</div>
      <p className="mt-3 border-t border-[#27272A] pt-2 text-[10px] text-zinc-500">Tip: start broad, run it once, then tighten thresholds if you get too many companies.</p>
    </PopoverContent>
  </Popover>
);
